import { getNestedTranslation } from '@colonist/i18n';
import { SharedStrings } from '@colonist/types';
import { BaseError } from './BaseError.ts';
import { ErrorTypes } from './ErrorEnums.ts';
import { LogSeverity } from './LogSeverity.ts';
export class ErrorDefault extends BaseError {
    static deserialize(data) {
        // eslint-disable-next-line
        // @ts-ignore
        return new ErrorDefault(data.title, data.description, data.httpStatusCode, data.logSeverity, data.redirectUrl);
    }
    constructor(title, message, httpStatusCode, logSeverity = LogSeverity.JL2, redirectUrl){
        super(title, message, httpStatusCode, logSeverity, redirectUrl), this.type = ErrorTypes.DefaultError;
    }
}
export class ErrorAuth extends BaseError {
    getDisplayMessage() {
        const displayMessage = {
            key: 'strings:popups.errors.authError.displayMessage'
        };
        const errorMessage = this.description.key;
        const standardErrorMessage = {
            key: 'strings:popups.errors.authError.standardErrorMessage',
            options: {
                email: SharedStrings.SUPPORT_EMAIL
            }
        };
        return getNestedTranslation(displayMessage, {
            errorMessage: {
                key: errorMessage
            },
            standardErrorMessage: standardErrorMessage
        });
    }
    static deserialize(data) {
        // eslint-disable-next-line
        // @ts-ignore
        return new ErrorAuth(data.title, data.description, data.httpStatusCode);
    }
    constructor(title, message, httpStatusCode, logSeverity = LogSeverity.JL4, redirectUrl){
        super(title, message, httpStatusCode, logSeverity, redirectUrl), this.type = ErrorTypes.AuthError;
    }
}
export class ErrorMustLogin extends BaseError {
    static deserialize(data) {
        // eslint-disable-next-line
        // @ts-ignore
        return new ErrorMustLogin(data.title, data.description, data.httpStatusCode);
    }
    constructor(title, message, httpStatusCode, logSeverity = LogSeverity.JL2){
        super(title, message, httpStatusCode, logSeverity), this.type = ErrorTypes.MustLogin;
    }
}
export class ErrorMustBeMember extends BaseError {
    static deserialize(data) {
        // eslint-disable-next-line
        // @ts-ignore
        return new ErrorMustBeMember(data.title, data.description, data.httpStatusCode, data.logSeverity);
    }
    constructor(title, message, httpStatusCode, logSeverity = LogSeverity.JL2){
        super(title, message, httpStatusCode, logSeverity), this.type = ErrorTypes.MustBeMember;
    }
}
export class ErrorBlocking extends BaseError {
    static deserialize(data) {
        // eslint-disable-next-line
        // @ts-ignore
        return new ErrorBlocking(data.title, data.description, data.httpStatusCode, data.logSeverity);
    }
    constructor(title, message, httpStatusCode, logSeverity = LogSeverity.JL2){
        super(title, message, httpStatusCode, logSeverity), this.type = ErrorTypes.Blocking;
    }
}
